import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import Downloader from "../../components/pdf_downloader/Downloader";

export default function FAQ(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Frequently Asked Questions (FAQs)</Typography>
            <hr/>
            <Box sx={{borderLeft:"5px solid #0b4285", padding:"2px 0 2px 10px", marginTop:"20px", backgroundColor:"whitesmoke"}}>
                <Downloader url={"pdf/faq/FAQ_NREGA_ENGLISH.pdf"} name={"Frequently Asked Questions on Implementation of MGNREGA (English Language)"}/> 
                <Downloader url={"pdf/faq/FAQ_NREGA_Khasi.pdf"} name={"Frequently Asked Questions on Implementation of MGNREGA (Khasi Language) "}/> 
                <Downloader url={"pdf/faq/FAQ_NREGA_Garo.pdf"} name={"Frequently Asked Questions on Implementation of MGNREGA (Garo Language)"}/> 
            </Box>
        </Box>
    )
}